import React from 'react';
import { Card, CardContent, CardHeader, Divider } from '@material-ui/core';
import { useTranslation } from 'react-i18next';
import { IQRCode } from './types';

/**
 * Represent the QR Code for the appointment
 *
 * @param {*} {  qrCode, ...rest }
 * @return {*}
 */
export const QRCode = ({ qrCode, ...props }: IQRCode) => {
    const { t } = useTranslation();

    return (
        <Card {...props}>
            <CardHeader title={t('Leads.QrCode')} />
            <Divider />
            <CardContent style={{ display: 'flex', justifyContent: 'center' }}>
                <img src={qrCode} alt="qr-code" width="50%" />
            </CardContent>
        </Card>
    );
};
